export enum KlusInputFormFieldNames {
  KlusSoort = "klusSoort",
  Rangeerbeweging = "relatieActieId",
  SpoorStart = "spoorStart",
  SpoorEind = "spoorEind",
  Begindatum = "beginDatum",
  Einddatum = "eindDatum",
  Begintijd = "beginTijd",
  Eindtijd = "eindTijd",
  Dienst = "dienst",
}
